var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Edit",
    transform: "translate(-1083 -308)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13492",
    "data-name": "Rectangle 13492",
    width: 20,
    height: 20,
    transform: "translate(1083 308)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_32911",
    "data-name": "Group 32911",
    transform: "translate(1087 311)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_147",
    "data-name": "Path 147",
    d: "M274.7,392.626a1.768,1.768,0,0,1,2.454-.239l1.365,1.061a1.687,1.687,0,0,1,.567,2.35c-.027.043-7.51,9.4-7.51,9.4a1.335,1.335,0,0,1-1.031.5l-2.866.036L267.035,403a1.283,1.283,0,0,1,.249-1.1Z",
    transform: "translate(-267 -392)",
    fill: "#0062ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_148",
    "data-name": "Path 148",
    d: "M275.021,395l4.293,3.3",
    transform: "translate(-268.705 -392.638)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit3);
export default __webpack_public_path__ + "static/media/edit-3.117bb526.svg";
export { ForwardRef as ReactComponent };